var o = {};

o.getScript = function ( url, callback ) {
	// Create a new script and setup the basics.
	var script = document.createElement( "script" ),
		firstScript = document.getElementsByTagName( 'script' )[0];

	script.async = true;
	script.src = url;

	// Handle the case where an optional callback was passed in.
	if ( "function" === typeof(callback) ) {
		script.onload = function () {
			callback();

			// Clear it out to avoid getting called more than once or any memory leaks.
			script.onload = script.onreadystatechange = undefined;
		};
		script.onreadystatechange = function () {
			if ( "loaded" === script.readyState || "complete" === script.readyState ) {
				script.onload();
			}
		};
	}

	// Attach the script tag to the page (before the first script) so the magic can happen.
	firstScript.parentNode.insertBefore( script, firstScript );
};

o.lazyload = {
	js: function ( urlarr, fn ) {
		o.getScript( urlarr[0], function () {
			fn();
		} );
	}
};

o.callcbarr = function ( cbarr ) {
	var args = [].slice.call( arguments, 1 );
	return cbarr.filter( function ( cb ) {
		cb.apply( 1, args );
	} );
};

o.getwisjruncached = function ( opts, fn ) {
	// some pages ESI include wisRegistration scripts
	// if such is case, do not request
	if ( typeof wisRegistration === 'object' ) {
		return fn( null, wisRegistration );
	}

	o.lazyload.js( [opts.url], function () {
		if ( typeof wisRegistration === 'object' ) {
			fn( null, wisRegistration );
		}
		else {
			fn( 'failed to load' );
		}
	} );
};

o.getwisjr = (function ( val, cbarr, isloading ) {
	cbarr = [];
	isloading = false;
	return function ( opts, fn ) {
		cbarr.push( fn );
		if ( isloading === false ) {
			isloading = val === undefined;
			if ( typeof val === 'undefined' ) {
				o.getwisjruncached( opts, function ( err, wisjr ) {
					isloading = false;
					cbarr = o.callcbarr( cbarr, err, opts, val = wisjr );
				} );
			}
			else {
				cbarr = o.callcbarr( cbarr, null, opts, val );
			}
		}
	}
}());

o.get = function ( fn ) {
	o.getwisjr( {
		url: 'http://www.foxsports.com/accounts/Static/Bundle/JS/WIS?v=20150828',
		wisjrfilter: function ( opts, wisjr ) {
			var wisjrwrapper = Object.create( wisjr );

			wisjrwrapper.getfirstName = function () {
				var firstName = "";
				var wisFirstName = wisjr.getFirstName();
				if (null !== wisFirstName && 'undefined' !== wisFirstName ) {
					firstName = wisFirstName.replace(/\+/g, " ");
				}
				return firstName;

			};
			wisjrwrapper.getfirstNameInitial = function () {
				var firstName = wisjr.getFirstName();
				var firstInitial = "";
				if ( null !== firstName  && 'undefined' !==  firstName  ) {
					firstInitial = firstName.charAt(0);
				}
				return firstInitial;

			};

			wisjrwrapper.getlastName = function () {
				var lastName = "";
				var wisLastName = wisjr.getLastName();
				if ( null !== wisLastName && 'undefined'  !== wisLastName ) {
					lastName = wisLastName.replace(/\+/g, " ");
				}
				return lastName;
			};

			wisjrwrapper.getlastNameInitial = function () {
				var lastName = wisjr.getLastName();
				var lastInitial = "";

				if ( null !== lastName && 'undefined' !== lastName  ) {
					lastInitial = lastName.charAt(0);
				}
				return lastInitial;
			};

			wisjrwrapper.onlogin = function ( fn ) {
				return wisjr.registerForLoginSuccess( fn );
			};

			wisjrwrapper.onlogout = function ( fn ) {
				return wisjr.registerForLogout( fn );
			};

			wisjrwrapper.renderlogin = function ( fn ) {
				return wisjr.startLoginWidget( fn );
			};

			wisjrwrapper.isLoggedIn = function () {
				return wisjr.isUserLoggedIn();
			};

			wisjrwrapper.isLoggedOut = function () {
				return ! this.isLoggedIn();
			};

			wisjrwrapper.logout = function () {
				return wisjr.logoutUser();
			};

			return wisjrwrapper;
		}
	}, function ( err, opts, wisjr ) {
		if ( err ) return fn( err );

		if ( typeof opts.wisjrfilter === 'function' ) {
			wisjr = opts.wisjrfilter( opts, wisjr );
		}

		fn( err, window.wisjr = wisjr );
	} );
};
let AccountsService = o;

export default AccountsService;



// WEBPACK FOOTER //
// ./assets/components/account/AccountsService.js